import React from "react";
import { styled } from "../../stitches.config";
import BackgroundImage from "../../assets/img/brid_background.jpg";
import DniLogo from "../../assets/img/dni_logo.svg";

import Box from "../../components/composition-components/Box";

interface IPost {
  title: string;
}
interface ISettings {
  b1: IPost;
}

interface BridPrimaryHeaderProps {
  settings: ISettings;
}

const BridPrimaryHeader: React.FC<BridPrimaryHeaderProps> = ({ settings, ...props }) => {

  return (
    <div style={{ paddingBottom: "56px" }}>
      <Root>
        <div className="container">
          <WrapperContent>
            <Box
              {...props}
              id="b1"
              type="BridPrimaryHeader"
              settings={settings.b1}
            />
            <Line />
            <Heading size="small">WYRÓŻNIENIE</Heading>
            <Paragraph variant="secondary">
              BRID otrzymał wyróżnienie prestiżowego Funduszu Google DNI,
              wspierającego innowacyjne pomysły dziennikarskie
            </Paragraph>
            <img src={DniLogo} />
          </WrapperContent>
        </div>
      </Root >
    </div >
  );
};

const Root = styled("div", {
  height: "480px",
  backgroundImage: `url("${BackgroundImage}")`,
  backgroundSize: "cover",
  backgroundPosition: "50% 50%",
  backgroudnRepeat: "no-repeat",
  padding: "70px 16px",
  "@bp4": {
    height: "624px"
  }
});

const WrapperContent = styled("div", {
  width: "100%",
  "@bp4": {
    width: "50%"
  },
  "@media (min-width: 1440px)": {
    width: "40%"
  }
});

const Heading = styled("h1", {
  color: "$grayscale0Fixed",
  fontSize: "12px",
  marginTop: 0,
  marginBottom: "8px",
  "@bp4": {
    fontSize: "12px"
  },
  variants: {
    "size": {
      "big": {
        fontSize: "34px",
        marginBottom: "16px",
        "@bp4": {
          fontSize: "54px"
        }
      },
      "small": {}
    }
  }
});

const Paragraph = styled("p", {
  color: "#ccc",
  fontSize: "14px",
  lineHeight: "18px",
  marginTop: 0,
  fontWeight: 600,
  marginBottom: "11px",
  "@bp4": {
    fontSize: "16px",
    lineHeight: "16px",
    marginBottom: "11px"
  },
  "a": {
    marginLeft: "4px",
    textDecoration: "underline",
    transition: "0.3s",
    "&:hover": {
      color: "$primary !important"
    }
  },
  variants: {
    "variant": {
      "primary": {
        color: "#fff",
        marginBottom: "24px",
        "@bp4": {
          marginBottom: "32px",
          lineHeight: "24px"
        }
      },
      "secondary": {}
    }
  }
});

const WrapperButtons = styled("div", {
  display: "flex"
});

const Button = styled("a", {
  width: "48%",
  color: "$grayscale100Fixed",
  backgroundColor: "#F5F5F5",
  border: "2px solid #F5F5F5",
  padding: "11px 25px",
  textAlign: "center",
  fontWeight: 600,
  cursor: "pointer",
  "&:hover, &:visited": {
    color: "$grayscale100Fixed",
    textDecoration: "none",
  },
  "@bp3": {
    width: "auto"
  },
  "&:first-child": {
    marginRight: "16px"
  },
  variants: {
    type: {
      "primary": {
        color: "$grayscale0Fixed",
        backgroundColor: "$primary",
        border: "2px solid #FF6400",
        "&:hover, &:visited": {
          color: "$grayscale0Fixed"
        }
      },
      "secondary": {}
    }
  }
});

const Line = styled("div", {
  display: "block",
  width: "100%",
  height: "1px",
  backgrundColor: "rgba(255,255,255, 0.1)",
  margin: "24px auto",
  "@bp4": {
    margin: "40px auto"
  }
});

export default BridPrimaryHeader;
